import { Chip } from "@mui/material";

/** Published ∣ Draft — the one thing a reseller-facing author checks first. */
export function PublishedChip({ published }: { published: boolean }): JSX.Element {
  return (
    <Chip
      size="small"
      label={published ? "Published" : "Draft"}
      color={published ? "success" : "default"}
      variant={published ? "filled" : "outlined"}
      data-testid="module-published-chip"
      data-published={published ? "true" : "false"}
      sx={{ fontWeight: 600 }}
    />
  );
}
